import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import type { Empresa } from '@/features/empresa/types/Empresa';
import { apiEmpresaGetQueryOptions } from '@/features/empresa/api/apiEmpresaGet';
import { useLoginStore } from '@/features/login/store';
import { updateEmpresa } from '@/features/login/util';

export function useEmpresaQuery(): {
    empresa: Empresa | undefined;
    isFetchingEmpresa: boolean;
} {
    const empresaIdpk = useLoginStore((s) => s.empresaIdpk);

    const { data: empresas, isFetching } = useQuery({
        ...apiEmpresaGetQueryOptions(),
        enabled: empresaIdpk != null,
        staleTime: Infinity,
    });

    const empresa = empresas?.[0];

    useEffect(() => {
        if (empresa) {
            updateEmpresa(empresa);
        }
    }, [empresa]);

    return {
        empresa,
        isFetchingEmpresa: isFetching,
    };
}
